// extracted by mini-css-extract-plugin
export default {"number":"numbers-carousel-module--number--2cbd7","selected":"numbers-carousel-module--selected--ff922"};